import React from 'react';
import PropTypes from 'prop-types';
import {
  FeatureDrawerActions,
  FeatureDrawerContent,
} from '../../../../knock-design-system';

export const ManageChannels = ({ handleDrawerMode }) => {
  return (
    <React.Fragment>
      <FeatureDrawerContent>Managing Channels</FeatureDrawerContent>
      <FeatureDrawerActions
        closeDrawer={handleDrawerMode(null)}
        primaryButtonText="Apply"
        secondaryButtonText="Cancel"
      />
    </React.Fragment>
  );
};

ManageChannels.propTypes = {
  handleDrawerMode: PropTypes.func,
};
